module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/flower-shop@2x_cd6e72.jpg";